module.exports = __webpack_public_path__ + "img/confirm-empty.fbf0a2a9.png";